export enum Availability {
  Unavailable,
  Visible,
  Possible,
  Available,
  Glitches,
  GlitchesVisible
}
